import React, { Component } from 'react';
import axios from 'axios';
import Container from '@material-ui/core/Container';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Button, Grid, withStyles, Typography } from '@material-ui/core';
import { API_URL, EVENT_ID, getUserID } from '../../constants';
import swal from 'sweetalert';

import VoteRes from './VoteRes';
import './Vote.css';
import LiveTopbar from '../../components/LiveTopbar';

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 20,
    // borderRadius: 5,
    margin: '7px 0 15px',
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    // borderRadius: 5,
    backgroundColor: '#b362b7',
  },
}))(LinearProgress);

const styles = (theme) => ({
  voteBtn: {
    width: '50px',
    height: '50px',
    backgroundColor: '#dddddd',
    borderRadius: '3px',
    display: 'flex',
  },
  selectBtn: {
    width: '50px',
    height: '50px',
    // backgroundColor: '#F4C5CC',
    backgroundColor: 'rgba(157,11,76,0.25)',
    borderRadius: '3px',
    display: 'flex',
  },
  radioBtn: {
    opacity: 0,
    position: 'absolute',
    width: '50px',
    height: '50px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  radioLabel: {
    width: '50px',
    height: '50px',
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  voteCnt: {
    position: 'absolute',
    right: 0,
    color: '#828282',
    fontSize: '14px',
  },
});

class Vote extends Component {
  //보팅 질문 문항 불러오기
  loadingData = async () => {
    try {
      axios
        .get(`${API_URL}/event/polls?eventId=${EVENT_ID}&channel=${this.props.channel}&session=${this.state.pgmId}`, {
          headers: { Pragma: 'no-cache' },
        })
        .then((res) => {
          let datas = res.data;
          // console.log(res);
          this.setState({
            itemList: datas.Items[0],
          });
          // this.forceUpdate();
        });
    } catch (e) {
      console.error(e);
    }
  };

  componentDidMount() {
    // console.log("이벤트아이디: " + EVENT_ID);
    // console.log("채널: " + this.props.channel);
    // console.log("세션아이디: " + this.state.pgmId);
    // console.log("보팅아이디: " + this.props.voteId);
    // console.log(this.props.count);

    // n개만큼 선택지 뿌리기 위해 가상 배열 만들기
    let arr = [];
    for (let i = 0; i < Number(this.state.voteCnt); i++) {
      arr.push(i + 1);
    }
    this.setState({ exList: arr }, console.log(this.state.exList));

    this.loadingData();

    //10초 후 자동으로 결과 화면으로 넘기기
    //setTimeout(() => this.setState({ isTimeout: true }), 10500);
  }

  constructor(props) {
    super(props);

    this.state = {
      pgmId: sessionStorage.getItem('_in_session'),
      isVoted: false,
      isTimeout: false,
      selected: null,
      itemList: [],
      exList: [],
      voteCnt: 5,
      totalCnt: 0,
      res1: 0,
      res2: 0,
      res3: 0,
      res4: 0,
      res5: 0,
      // res6: 0,
    };

    this.voteSubmit = this.voteSubmit.bind(this);
  }

  /*
  setVoted = (value, cnt) => {
    // console.log("보팅보팅");
    // console.log(value);
    // console.log(cnt);
    this.setState({ isVoted: value, voteCnt: cnt }, () => {
      this.loadingData();
    });
  };
*/
  handleSubmit(event) {
    alert('입력하신 값은 ' + this.state.selected);
    event.preventDefault();
  }

  handleBtn(val) {
    this.setState({ selected: val });
    // setTimeout(console.log("선택하신 번호는 " + this.state.selected), 1000);
  }

  handleRadioChange = (event) => {
    if (this.state.selected) {
      let t = document.getElementsByName('tx' + this.state.selected)[0];
      t.classList.remove('selected');
    }

    let f = document.getElementsByName('tx' + event.target.value)[0];
    f.classList.add('selected');
    this.setState({ selected: event.target.value });
  };

  voteSubmit() {
    // console.log("submit");
    // console.log(this.state.selected);
    if (!this.state.selected) {
      // alert('문항을 선택하세요');
      swal('', '문항을 선택하세요', 'warning');
      return;
    }

    //const username = sessionStorage.getItem('_in_name');

    //evt=evt019&userid=evt019_01088805968&username=이충무&channel=REPOM&answer=1

    if (this.props.callBack) {
      this.props.callBack();
    }
    const username = sessionStorage.getItem('_in_name');
    console.log(`evt=${EVENT_ID}&userid=${getUserID()}&username=${username}&channel=${this.props.channel}&answer=${this.state.selected}`);
    fetch(`${API_URL}/voting/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: `evt=${EVENT_ID}&userid=${getUserID()}&username=${username}&channel=${this.props.channel}&answer=${this.state.selected}`,
    })
      .then((res) => {
        console.log(res);
        //this.setState({ isVoted: true });
        // this.state.selected = null;
        // alert('보팅 완료');
        swal('', '', 'success');
        /*
        if (res.status === 200) {
          swal('', '제출되었습니다.', 'success');
        } else {
          swal('', '제출이 마감되었습니다.', 'warning');
        }
        */
      })
      .catch((err) => {
        console.log(err);
        // this.state.selected = null;
        // alert('보팅 실패');
        swal('', '제출 실패', 'warning');
      });
  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <LiveTopbar ch={this.state.channelId} callFunction={1} />
        {this.state.isVoted === false ? (
          <Container style={{ height: '100%' }}>
            {/*
            <Typography variant="h5" style={{ fontSize: "14px", marginBottom: "1.5em" }}>
              25초 이내에 보팅하지 않으면, 자동으로 결과 화면으로 넘어갑니다.
            </Typography>*/}

            {/* <form onSubmit={this.handleSubmit}> */}
            <FormControl style={{ minWidth: '100%' }}>
              <RadioGroup value={this.state.selected} onChange={this.handleRadioChange}>
                <Grid container spacing={2}>
                  {/* {this.state.exList.map((item, i) => {
                    return (
                      <Grid item container xs={12} style={{ padding: 0 }}>
                        <Grid item>
                          <div name={"tx" + (i + 1)} className={classes.selectBtn}>
                            <Radio value={i + 1} id={i + 1} className={classes.radioBtn} />
                            <label htmlFor="1" className={classes.radioLabel}>
                              {i + 1}
                            </label>
                          </div>
                        </Grid>
                        <Grid item alignItems={"center"} style={{ display: "flex" }}>
                          <Typography display={"inline"} style={{ paddingLeft: "1em" }}>
                            {i + 1}번
                          </Typography>
                        </Grid>
                        <Grid item xs={12} style={{ padding: "0 0 8px" }}>
                          <BorderLinearProgress variant="determinate" value={0} />
                        </Grid>
                      </Grid>
                    );
                  })} */}

                  <Grid item container xs={12} style={{ padding: 0 }}>
                    <Grid item>
                      <div name={'tx1'} className={classes.selectBtn}>
                        <Radio value={1} id={1} className={classes.radioBtn} />
                        <label htmlFor="1" className={classes.radioLabel}>
                          1
                        </label>
                      </div>
                    </Grid>
                    <Grid item alignItems={'center'} style={{ display: 'flex' }}>
                      <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                        1번
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                      <BorderLinearProgress variant="determinate" value={0} />
                    </Grid>
                  </Grid>
                  <Grid item container xs={12} style={{ padding: 0 }}>
                    <Grid item>
                      <div name={'tx2'} className={classes.selectBtn}>
                        <Radio value={2} id={2} className={classes.radioBtn} />
                        <label htmlFor="2" className={classes.radioLabel}>
                          2
                        </label>
                      </div>
                    </Grid>
                    <Grid item alignItems={'center'} style={{ display: 'flex' }}>
                      <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                        2번
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                      <BorderLinearProgress variant="determinate" value={0} />
                    </Grid>
                  </Grid>
                  {this.state.voteCnt > 2 ? (
                    <Grid item container xs={12} style={{ padding: 0 }}>
                      <Grid item>
                        <div name={'tx3'} className={classes.selectBtn}>
                          <Radio value={3} id={3} className={classes.radioBtn} />
                          <label htmlFor="3" className={classes.radioLabel}>
                            3
                          </label>
                        </div>
                      </Grid>
                      <Grid item alignItems={'center'} style={{ display: 'flex' }}>
                        <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                          3번
                        </Typography>
                      </Grid>
                      <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                        <BorderLinearProgress variant="determinate" value={0} />
                      </Grid>
                    </Grid>
                  ) : (
                    ''
                  )}
                  {this.state.voteCnt > 3 ? (
                    <Grid item container xs={12} style={{ padding: 0 }}>
                      <Grid item>
                        <div name={'tx4'} className={classes.selectBtn}>
                          <Radio value={4} id={4} className={classes.radioBtn} />
                          <label htmlFor="4" className={classes.radioLabel}>
                            4
                          </label>
                        </div>
                      </Grid>
                      <Grid item alignItems={'center'} style={{ display: 'flex' }}>
                        <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                          4번
                        </Typography>
                      </Grid>
                      <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                        <BorderLinearProgress variant="determinate" value={0} />
                      </Grid>
                    </Grid>
                  ) : (
                    ''
                  )}
                  {this.state.voteCnt > 4 ? (
                    <Grid item container xs={12} style={{ padding: 0 }}>
                      <Grid item>
                        <div name={'tx5'} className={classes.selectBtn}>
                          <Radio value={5} id={5} className={classes.radioBtn} />
                          <label htmlFor="5" className={classes.radioLabel}>
                            5
                          </label>
                        </div>
                      </Grid>
                      <Grid item alignItems={'center'} style={{ display: 'flex' }}>
                        <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                          5번
                        </Typography>
                      </Grid>
                      <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                        <BorderLinearProgress variant="determinate" value={0} />
                      </Grid>
                    </Grid>
                  ) : (
                    ''
                  )}
                  {/* {this.state.voteCnt > 5 ? (
                    <Grid item container xs={12} style={{ padding: 0 }}>
                      <Grid item>
                        <div name={'tx6'} className={classes.selectBtn}>
                          <Radio value={6} id={6} className={classes.radioBtn} />
                          <label htmlFor="6" className={classes.radioLabel}>
                            6
                          </label>
                        </div>
                      </Grid>
                      <Grid item alignItems={'center'} style={{ display: 'flex' }}>
                        <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                          6번
                        </Typography>
                      </Grid>
                      <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                        <BorderLinearProgress variant="determinate" value={0} />
                      </Grid>
                    </Grid>
                  ) : (
                    ''
                  )} */}
                </Grid>
                <Button variant="outlined" color="primary" onClick={() => this.voteSubmit()}>
                  제출하기
                </Button>
              </RadioGroup>
            </FormControl>
            {/* </form> */}
          </Container>
        ) : (
          <VoteRes channel={this.props.channel} count={this.props.count} voteId={this.props.voteId} exList={this.state.exList} />
        )}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(Vote);
